import styled from 'styled-components';
import {Button, Space} from 'antd';
import {agentSenderStyles, iconColor, typographyStyles} from '../../../utils/styles';

const StyledFullWidthAgentChatEmptyStateContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: calc(100vh - var(--agent-chat-header-height));
  justify-content: center;
  overflow-y: auto;
  padding: 24px 19px;
  width: 100%;
`;

const StyledFullWidthAgentChatEmptyStateTitle = styled.div`
  ${typographyStyles.heading.h3};
  text-align: center;
`;

const StyledFullWidthAgentChatEmptyStateContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 720px;
  width: 100%;

  ${agentSenderStyles};

  .ant-sender {
    border: 1px solid ${props => props.theme.colors.neutral_3};
    box-shadow: 0 1px 4px rgba(0, 0, 0, .06);

    &:after {
      content: none;
    }
  }
`;

const StyledFullWidthAgentChatEmptyStateActionsRow = styled(Space)`
  align-self: center;
  justify-content: center;
  width: 100%;
`;

const StyledFullWidthAgentChatEmptyStateOptionsLabel = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_7};
  font-weight: 600;
  margin: 0 auto;
  max-width: 720px;
  text-transform: uppercase;
  width: 100%;
`;

const StyledFullWidthAgentChatEmptyStateOptionsGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, 1fr);
  margin: 0 auto;
  max-width: 720px;
  width: 100%;
`;

const StyledFullWidthAgentChatEmptyStateOptionCard = styled(Button)`
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_1};
  border: 1px solid ${props => props.theme.colors.neutral_3};
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .06);
  display: flex;
  height: auto;
  justify-content: space-between;
  padding: 14px 16px;
  text-align: left;
  white-space: normal;
  width: 100%;

  svg {
    ${props => iconColor(props.theme.colors.neutral_6)}
  }

  &:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: ${props => props.theme.colors.neutral_1} !important;
    border-color: ${props => props.theme.colors.primary_7} !important;

    svg {
      ${props => iconColor(props.theme.colors.primary_7)}
    }
  }

  span {
    ${typographyStyles.body.regular};
  }
`;

const StyledFullWidthAgentChatEmptyStateDescription = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_7};
  margin: 8px auto 0 auto;
  max-width: 720px;
  text-align: center;
  width: 100%;
`;

export {
  StyledFullWidthAgentChatEmptyStateContainer,
  StyledFullWidthAgentChatEmptyStateTitle,
  StyledFullWidthAgentChatEmptyStateContentWrapper,
  StyledFullWidthAgentChatEmptyStateActionsRow,
  StyledFullWidthAgentChatEmptyStateOptionsLabel,
  StyledFullWidthAgentChatEmptyStateOptionsGrid,
  StyledFullWidthAgentChatEmptyStateOptionCard,
  StyledFullWidthAgentChatEmptyStateDescription,
}
